<nav class="navbar navbar-expand-lg nav-crev" [class.nav-scroll]="isSticky">
    <div class="container">
        <a class="navbar-brand icon-img-100" [routerLink] = "'/'">
            <img [src]="logo" alt="Logo" class="logo">
        </a>
        <button class="navbar-toggler ms-auto" type="button" (click)="isCollapsed = !isCollapsed" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" [attr.aria-expanded]="!isCollapsed" aria-label="Toggle navigation">
            <span class="icon-bar"><i class="icofont icofont-navigation-menu"></i></span>
        </button>
        <div class="collapse navbar-collapse" [ngClass]="{'collapse': isCollapsed, 'navbar-collapse': true}" id="navbarNavAltMarkup">
            <ul class="navbar-nav navbar-center xs-mt-20">
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('home')">Home</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('solutions')">Solutions</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('products')">Products</a>
                </li>
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('distributors')">Distributor Solutions</a></li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('about')">About</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('support')">Support</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" (click)="scrollToSection('contact')">Contact</a>
                </li>
            </ul>
          <div class="nav-button ms-auto xs-ml-0 xs-mt-20"><a href="#contact" (click)="scrollToSection('contact')" class="btn btn-md btn-gradient-primary btn-circle">Book a Demo</a></div>

        </div>

    </div>
</nav>
